module.exports = __webpack_public_path__ + "img/10-mob.bc86a9d2.png";